import { NewFindingStatus } from '../annotation.types';
import { AnnotationAssessment } from './AnnotationForm.types';

export const ThousandSeparatorDotRegex = /\$\s?|(\.*)/g;
export const CommaSeparatorToDotRegex = /,/g;

export const prepareDoubleValue = (value: string) => {
  value = value === '' ? '0' : value;
  const inputValue = parseFloat(value);

  return inputValue;
};

export const prepareIntValue = (value: string) => {
  const inputValue = value && value !== '' ? parseInt(value).toLocaleString('en-US', { maximumFractionDigits: 0, minimumFractionDigits: 0 }) : '';
  return inputValue;
};

export const restrictInputFor2Decimals = (value: string) => {
  return inspectRegex(value, /^\s*-?((\d|\.)+(,)?(,\d{1,2})?|(,\d{1,2})?)\s*$/);
};

export const restrictInputForDigitsAndSeparators = (value: string) => {
  return inspectRegex(value, /^\d*([.]\d+)*$/);
};

export const restrictInputForDigits = (value: string) => {
  return inspectRegex(value, /^\d*$/);
};

export const restrictInputForVersionNumber = (value: string) => {
  return inspectRegex(value, /^\d+(\.\d+){0,3}$/) || checkForLastDot(value) || !value.length;
};

const checkForLastDot = (value: string) => {
  if (value[value.length - 1] === '.') {
    if (value.split('.').length - 1 === 4) {
      return false;
    }

    return true;
  }

  return false;
};

const inspectRegex = (value: string, pattern: RegExp) => {
  var regex = new RegExp(pattern);
  if (regex.test(value)) {
    return true;
  } else {
    return false;
  }
};

export const isAssessmentCompleted = (assessment: AnnotationAssessment | null) =>
  !!assessment && assessment.status === NewFindingStatus.AssessmentCompleted;

export const isStringNullOrEmpty = (value: string | undefined | null) => !(value && value.trim().length);
